<template>
	<div class="search_wrap">
		<div class="se_pc" v-if="!isPhone">
			<div class="se_pc_box">
				<div class="pcse_wrap">
					<div class="pcse_box">
						<div class="pcse_put">
							<input type="text" v-model="newsKey" placeholder="请输入关键字">
							<button type="button" @click="searchBtn"></button>
						</div>
						<p class="pcse_num">{{totalNum}}条剑南春搜索结果</p>
					</div>
					<ul class="pc_news_ul">
						<li class="pc_news_li" v-for="(item,index) in nesList" :key="index" @click="toDetail(item)">
							<div class="pc_news_li_con">
								<p class="pcli_p1">{{item.publishtime}}</p>
								<p class="pcli_p2">{{item.title}}</p>
								<p class="pcli_p3">{{item.summary}}</p>
							</div>
						</li>
					</ul>
					<div class="fenye" v-if="totalPage>0">
						<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
							@page-change="handlePageChange" />
					</div>
				</div>
			</div>
            <div class="rd_box"><record></record></div>
		</div>
		<div class="se_phone" v-if="isPhone">
			<Header2 :searchShow="false" :meauShow="false" pageTitle="搜索"></Header2>
			<div class="network">
				<div class="nw_wrap">
					<div class="nw_search">
						<div class="am_list">
							<div class="am_input">
								<input type="text" v-model="newsKey" placeholder="剑南春">
							</div>
						</div>
						<div class="am_zoom">
							<img @click="searchBtn" src="@/images/zoom2.png">
						</div>
					</div>
				</div>
				<p class="totel_num">
					共{{totalNum}}条查询结果
				</p>
				<div class="lists_news">
					<div class="item_news" v-for="(item,index) in nesList" :key="index" @click="toDetail(item)">
						<span class="item_news_left">1</span>
						<div class="item_news_right">
							<p class="nrt_p1">{{item.title}}</p>
							<p class="nrt_p2">{{item.summary}}</p>
							<p class="nrt_p3">{{item.publishtime}}</p>
						</div>
					</div>
				</div>
				<div class="fenye" v-if="totalPage>0">
					<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
						@page-change="handlePageChange" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2,
	},
	data() {
		return {
			newsKey: '',
			nesList: [],
			currentPage: 1,
			totalNum: 0,
			totalPage: 0,
			isPhone: this.$isMobile,
		}
	},
	created() {
		if (this.$route.query.newsKey) {
			this.newsKey = this.$route.query.newsKey;
		}
		this.searchnew();
	},
	methods: {
		// 新闻列表
		async searchnew() {
			var data2 = {
				keyword: this.newsKey,
				page: this.currentPage - 1,
				nums: 10,
			};
			const res = await this.$api.searchnew(data2);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.nesList = res.data;
				}
			}
		},
		searchBtn() {
			this.currentPage = 1;
			this.nesList = [];
			this.searchnew();
		},
		toDetail(item) {
			this.$router.push("/newsDetail?xid=" + item.id + '&typeid=' + item.typeid);
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.searchnew();
		},
	}
}
</script>

<style lang="scss">
.search_wrap {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.se_pc {
		padding-top: 80px;
		padding-bottom: 80px;
		background-image: url("../../images/bgimg3.png");
		min-height: 800px;
		.se_pc_box {
			max-width: 1296px;
            min-width: 950px;
			margin: 65px auto;
			padding: 104px 20px 90px;
			background-color: hsla(0, 0%, 100%, 0.6);
			min-height: 680px;
			box-sizing: border-box;
			.pcse_wrap {
				max-width: 860px;
				margin: 0 auto;
				.pcse_box {
					.pcse_put {
						display: flex;
						align-items: center;
						background-color: #fff;
						box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
						height: 69px;
						input {
							flex: 1;
							color: #262626;
							font-size: 36px;
							height: 69px;
							padding: 0 42px;
							border: none;
							outline: none;
							margin-right: 2px;
						}
						button {
							width: 88px;
							flex-shrink: 0;
							height: 69px;
							background-image: url("../../images/news/zoom1.png");
							background-repeat: no-repeat;
							background-position: 50%;
							border: none;
							outline: none;
							background-color: #fff;
							cursor: pointer;
						}
					}
					.pcse_num {
						color: #666;
						font-size: 22px;
						padding: 10px 42px 0;
						margin-bottom: 32px;
						text-align: left;
					}
				}
				.pc_news_ul {
					display: flex;
					flex-wrap: wrap;
					margin: 0 -20px;
					.pc_news_li {
						width: 50%;
						padding: 0 20px;
						margin-bottom: 32px;
						box-sizing: border-box;
						cursor: pointer;
						.pc_news_li_con {
							background-color: #fff;
							box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.1);
							padding: 16px 25px;
							border: 1px solid #fff;
							box-sizing: border-box;
							&:hover {
								border: 1px solid red !important;
							}
							.pcli_p1 {
								color: #999;
								font-size: 16px;
								margin-bottom: 5px;
								text-align: left;
							}
							.pcli_p2 {
								color: #333;
								font-size: 18px;
								line-height: 1.7;
								margin-bottom: 5px;
								height: 60px;
								overflow: hidden;
								text-align: left;
							}
							.pcli_p3 {
								color: #666;
								font-size: 14px;
								line-height: 1.8;
								border-top: 2px solid #ededed;
								padding-top: 10px;
								height: 62px;
								overflow: hidden;
								text-align: left;
								box-sizing: border-box;
							}
						}
					}
				}
				.fenye {
					margin-top: 30px;
				}
			}
		}
	}
	.se_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 1.2rem 0 2.5rem 0;
		min-height: 90vh;
		.network {
			.nw_wrap {
				padding: 0.4rem 0.53rem 0.47rem;
				box-sizing: border-box;
				.nw_search {
					background-color: #fff;
					height: 1.17rem;
					padding: 0 0.33rem;
					border-radius: 1.17rem;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.am_list {
						box-sizing: border-box;
						flex: 1;
						.am_input {
							input {
								color: #666;
								font-size: 17px;
								width: 100%;
								height: 1.17rem;
								border-radius: 1.17rem;
								background-color: #fff;
								border: none;
								outline: none;
							}
						}
					}
					.am_zoom {
						width: 1rem;
						text-align: center;
						img {
							width: 0.45rem;
						}
					}
				}
			}
			.totel_num {
				padding: 0 0.53rem;
				color: #666;
				text-align: left;
			}
			.lists_news {
				padding: 0 0.53rem;
				box-sizing: border-box;
				.item_news {
					overflow: hidden;
					background-color: #fff;
					padding: 10px 20px 5px 10px;
					margin-top: 20px;
					display: flex;
					justify-content: space-between;
					box-sizing: border-box;
					.item_news_left {
						font-size: 22px;
						color: #ccc;
						padding-right: 10px;
					}
					.item_news_right {
						flex: 1;
						p {
							text-align: left;
						}
						.nrt_p1 {
							font-size: 20px;
							line-height: 28px;
							color: #000;
							padding-bottom: 5px;
							border-bottom: 1px solid #efefef;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.nrt_p2 {
							font-size: 16px;
							color: #666;
							margin: 10px 0;
							line-height: 26px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.nrt_p3 {
							font-size: 14px;
							color: #999;
							text-align: right;
						}
					}
				}
			}
			.fenye {
				margin-top: 0.3rem;
				display: flex;
				justify-content: center;
			}
		}
	}
}
</style>